module.exports = __webpack_public_path__ + "static/media/lepes11.309a7c1a.png";